module.exports = "\n  .not-valid {\n    border: 2px solid red;\n  }"